import { ElegiblePMsActionType } from './actions'
import * as AT from './actionTypes'
import { Eligibile } from './types'

type CurrencyElegiblePaymentTypeState = {
  readonly data?: Eligibile[]
  readonly error?: string
  readonly fetching: boolean
}

export type EligiblePaymentTypeState = Partial<Record<string, CurrencyElegiblePaymentTypeState>>

export const INITIAL_STATE: EligiblePaymentTypeState = {}
const CURRENCY_INITAL_STATE = {
  fetching: false
}

const currencyElegiblePayment = (
  state: CurrencyElegiblePaymentTypeState = CURRENCY_INITAL_STATE,
  action: ElegiblePMsActionType
) => {
  switch (action.type) {
    case AT.SET_ELEGIBLE_PMS_TYPE:
      return { ...state, data: action.payload.data }
    case AT.SET_FETCHING_ELEGIBLE_PMS_TYPE:
      return { ...state, fetching: action.payload.fetching }
    case AT.SET_FETCH_ELEGIBLE_ERROR_PMS_TYPE:
      return { ...state, error: action.payload.error }
    case AT.FETCH_ELEGIBLE_PMS_TYPE:
      return { ...state, error: undefined }
    default:
      return state
  }
  return state
}

const elegibleReducer = (
  state: EligiblePaymentTypeState = INITIAL_STATE,
  action: ElegiblePMsActionType
) => {
  if (!action) return state

  return {
    ...state,
    [action.payload.currency]: currencyElegiblePayment(state[action.payload.currency], action)
  }
}

export default elegibleReducer
